import VisuallyHiddenLabel from './VisuallyHiddenLabel';

export default VisuallyHiddenLabel;